// pages/Register.jsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from "react-router";
export default function Register() {
  const [step, setStep] = useState(1);
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    contactNumber: '',
    sponsorId: '',
    sponsorDetails: null
  });
  const navigate = useNavigate();
  const { setIsAuthenticated } = useAuth();
const handleLogin = () => {
  sessionStorage.setItem('userData', JSON.stringify({ user: 'test' }));
  setIsAuthenticated(true);
  navigate("/home");
};
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData({ ...userData, [name]: value });
  };

  const handleNext = () => {
    console.log(step)
    if (step === 3 && userData.sponsorId) {
      // Simulate fetching sponsor details
      setUserData({
        ...userData,
        sponsorDetails: {
          name: 'Sponsor Name',
          email: 'sponsor@example.com',
          contactNumber: '123-456-7890'
        }
      });
    }
    if(step < 6 && step > 0)
      setStep(step + 1);
    console.log(step)
  };

  return (
    <div className="container-fluid">
      <div
        className="row h-100 align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
          <div className="bg-secondary rounded p-4 p-sm-5 my-4 mx-3">
          <div className="d-flex align-items-center justify-content-between mb-3">
              <a href="/" >
                <h3 className="text-primary">
                  <i className="fa fa-user-edit me-2" />
                  Quantium Chain
                </h3>
              </a>
            </div>
            <div className="d-flex align-items-center justify-content-between mb-3">
              
                <h6 className="text-primary">
                  Welcome to Quantium Chain. Please Follow Steps for Registration 
                </h6>
              
            </div>

            {step === 1 && (
              <button className="btn btn-primary w-100 mb-4" onClick={handleNext}>
                Sign Up With CryptoWallet
              </button>
            )}

            {step === 2 && (
              <div>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Name"
                  name="name"
                  value={userData.name}
                  onChange={handleChange}
                />
                <input
                  type="email"
                  className="form-control mb-3"
                  placeholder="Email"
                  name="email"
                  value={userData.email}
                  onChange={handleChange}
                />
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Contact Number"
                  name="contactNumber"
                  value={userData.contactNumber}
                  onChange={handleChange}
                />
                <button className="btn btn-primary w-100" onClick={handleNext}>
                  Next
                </button>
              </div>
            )}

            {step === 3 && (
              <div>
                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Sponsor ID"
                  name="sponsorId"
                  value={userData.sponsorId}
                  onChange={handleChange}
                />
                <button className="btn btn-primary w-100" onClick={handleNext}>
                  Check Sponsor
                </button>
              </div>
            )}

            {step === 4 && userData.sponsorDetails && (
              <div>
                <h5>Sponsor Details</h5>
                <p>Name: {userData.sponsorDetails.name}</p>
                <p>Email: {userData.sponsorDetails.email}</p>
                <p>Contact: {userData.sponsorDetails.contactNumber}</p>
                <h5>Your Details</h5>
                <p>Name: {userData.name}</p>
                <p>Email: {userData.email}</p>
                <p>Contact: {userData.contactNumber}</p>
                <button className="btn btn-primary w-100 mt-3" onClick={handleNext}>
                  Confirm & Proceed
                </button>
              </div>
            )}

            {step === 5 && (
              <div>
                <h5>Registration Successful!</h5>
                <p>Your Login ID: <strong>user123</strong></p>
                <button className="btn btn-primary w-100 mt-3" onClick={handleLogin}>
                  Go to Login
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
